import { useState } from "react";
import "./OrderInfo.scss";
import "./OrderInfoMobile.scss";

export default function OrderInfo({
  setProgress,
  progress,
  setIsCancelled,
  selectedOrders,
  setPaymentType,
  paymentType,
  amountToPay,
  setAmountToPay,
  hasPartial,
}) {
  // state for payment type
  // totals

  const totalPrice = hasPartial
    ? selectedOrders.reduce((sum, item) => sum + item.COI_Balance, 0)
    : selectedOrders.reduce(
        (sum, item) => sum + item.COI_UnitPrice * item.COI_Quantity,
        0
      );

  // Total downpayment
  const totalDownpayment = selectedOrders.reduce(
    (sum, item) => sum + item.PD_DownPayment * item.COI_Quantity,
    0
  );
  const balance = totalPrice - totalDownpayment;
  //console.log("hasPartial: ", hasPartial);

  return (
    <div className="ord-info-modal-container">
      <h2>ORDER INFORMATION</h2>
      <span className="subject">Please confirm order details below</span>
      {hasPartial ? (
        <>
          <table>
            <thead></thead>
            <tbody>
              <tr className="OSheader">
                <td className="col1" colSpan={2}>
                  ITEM NAME
                </td>
                <td className="col2">DEPOSITED</td>
                <td className="col4">BALANCE</td>
              </tr>

              {selectedOrders.map((item, idx) => (
                <tr key={idx} className="items">
                  <td className="col1" colSpan={2}>
                    {item.PD_Name}
                  </td>
                  <td className="col3">{item.COI_Downpayment}</td>
                  <td className="col4">PHP {item.COI_Balance}</td>
                </tr>
              ))}

              <tr className="division">
                <td colSpan={5}></td>
              </tr>
              <tr className="total">
                <td colSpan={2}>TOTAL AMOUNT:</td>
                <td colSpan={3}>PHP {totalPrice}</td>
              </tr>
            </tbody>
          </table>
        </>
      ) : (
        <>
          <table>
            <thead></thead>
            <tbody>
              {paymentType === "full" ? (
                <>
                  <tr className="OSheader">
                    <td className="col1" colSpan={2}>
                      ITEM NAME
                    </td>
                    <td className="col2">UNIT PRICE</td>
                    <td className="col3">QTY</td>
                    <td className="col4">SUBTOTAL</td>
                  </tr>

                  {selectedOrders.map((item, idx) => (
                    <tr key={idx} className="items">
                      <td className="col1" colSpan={2}>
                        {item.PD_Name}
                      </td>
                      <td className="col2">PHP {item.COI_UnitPrice}</td>
                      <td className="col3">{item.COI_Quantity}x</td>
                      <td className="col4">
                        PHP {item.COI_UnitPrice * item.COI_Quantity}
                      </td>
                    </tr>
                  ))}

                  <tr className="division">
                    <td colSpan={5}></td>
                  </tr>
                  <tr className="total">
                    <td colSpan={2}>TOTAL AMOUNT:</td>
                    <td colSpan={3}>PHP {totalPrice}</td>
                  </tr>
                </>
              ) : (
                <>
                  <tr className="OSheader">
                    <td className="col1" colSpan={2}>
                      ITEM NAME
                    </td>
                    <td className="col02">UNIT PRICE</td>
                    <td className="col03">DP UNIT</td>
                    <td className="col04">QTY</td>
                    <td className="col05">SUBTOTAL</td>
                  </tr>

                  {selectedOrders.map((item, idx) => (
                    <tr key={idx} className="items">
                      <td className="col01" colSpan={2}>
                        {item.PD_Name}
                      </td>
                      <td className="col02">PHP {item.COI_UnitPrice}</td>
                      <td className="col03">PHP {item.PD_DownPayment}</td>
                      <td className="col04">{item.COI_Quantity}x</td>
                      <td className="col05">
                        PHP {item.PD_DownPayment * item.COI_Quantity}
                      </td>
                    </tr>
                  ))}

                  <tr className="division">
                    <td colSpan={6}></td>
                  </tr>
                  <tr className="total">
                    <td colSpan={2}>TOTAL DOWNPAYMENT:</td>
                    <td colSpan={4}>PHP {totalDownpayment}</td>
                  </tr>
                </>
              )}

              <tr className="total">
                <td colSpan={paymentType === "full" ? 5 : 6}>
                  <div className="paymentMethod">
                    <button
                      className={`Payment ${
                        paymentType === "full" ? "active" : ""
                      }`}
                      onClick={() => setPaymentType("full")}
                    >
                      <div className="titleRadio">
                        <input
                          type="checkbox"
                          name="payment"
                          checked={paymentType === "full"}
                          onChange={() => setPaymentType("full")}
                        />
                        <span className="type">FULL PAYMENT</span>
                      </div>
                      <span className="price">
                        TOTAL PRICE: PHP {totalPrice}
                      </span>
                    </button>

                    <button
                      className={`Payment ${
                        paymentType === "partial" ? "active" : ""
                      }`}
                      onClick={() => setPaymentType("partial")}
                    >
                      <div className="titleRadio">
                        <input
                          type="checkbox"
                          name="payment"
                          checked={paymentType === "partial"}
                          onChange={() => setPaymentType("partial")}
                        />
                        <span className="type">PARTIAL PAYMENT</span>
                      </div>
                      <>
                        <span className="price">
                          TOTAL DP: PHP {totalDownpayment}
                        </span>
                        <span className="priceBal">BALANCE: PHP {balance}</span>
                      </>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
      <div className="action-button">
        <button
          className="cancel"
          onClick={() => {
            setIsCancelled(true);
          }}
        >
          CANCEL
        </button>
        <button
          className="proceed"
          onClick={() => {
            if (hasPartial) {
              setPaymentType("full");
              setAmountToPay(totalPrice);
            } else {
              setAmountToPay(
                paymentType === "full" ? totalPrice : totalDownpayment
              );
            }
            setProgress(progress + 1);
          }}
        >
          PROCEED
        </button>
      </div>
    </div>
  );
}
